export const optionalRightsConfig = {
  headings: [
    {
      headingLabel: "Item",
      inputType: "label",
      icon: "",
      border: true,
      width: "5%",
      selectOptions: [],
    },
    {
      headingLabel: "Description",
      inputType: "richtexteditor",
      border: true,
      width: "29%",
    },
    {
      headingLabel: "Service",
      inputType: "searchselectid",
      border: true,
      width: "13%",
      selectOptions: [],
    },
    {
      headingLabel: "Language",
      inputType: "searchselectid",
      border: true,
      width: "13%",
      selectOptions: [],
    },
    {
      headingLabel: "Qty",
      inputType: "number",
      border: true,
      width: "7%",
      selectOptions: [],
    },
    {
      headingLabel: "Unit Cost",
      inputType: "number",
      border: true,
      width: "9%",
    },
    // {
    //   headingLabel: "Sub Total",
    //   inputType: "label",
    //   border: true,
    //   width: "9%",
    // },
    // {
    //   headingLabel: "Currency",
    //   inputType: "label",
    //   border: true,
    //   width: "7%",
    // },
    // {
    //   headingLabel: "Exchange Rate",
    //   inputType: "number",
    //   border: true,
    //   width: "10%",
    //   selectOptions: [],
    // },
    {
      headingLabel: "Total Cost",
      inputType: "label",
      border: true,
      width: "10%",
    },
  ],
  dataNodes: [
    // "gl_number",
    // "setunit_id",
    // "chartofaccount_id",
    "item_no",
    "description",
    "service_id",
    "target_language_id",
    "quantity",
    "unit_cost",
    // "subtotal_value",
    // "currency_code",
    // "adj_curr_exch_rate",
    "total_cost_value",
  ],
  primaryKey: ["po_line_id"],
  isHboTenant:["HBO"],
  nodeFields: [
    {
      column: "info",
    },
  ],
  inlineEdits: [
    {
      dataNode: "item_no",
      width: "5%"
    },
    {
      dataNode: "description",
      width: "29%",
      placeholder: "Description",
    },
    {
      dataNode: "service_id",
      width: "13%",
      placeholder: "- Type to search -",
    },
    {
      dataNode: "target_language_id",
      width: "13%",
      placeholder: "- Type to search -",
    },
    {
      dataNode: "quantity",
      width: "7%",
      validateMethod: "validateNumberFloatOnly",
      placeholder: "Qty",
      // isMandatory: true,
    },
    {
      dataNode: "unit_cost",
      width: "9%",
      placeholder: "Unit Cost",
      validateMethod: "validateNumberFloatOnly",
      // isMandatory: true,
    },
    // {
    //   dataNode: "subtotal_value",
    //   width: "7%",
    // },
    // {
    //   dataNode: "currency_code",
    //   width: "7%",
    //   placeholder: "Currency",
    // },
    // {
    //   dataNode: "adj_curr_exch_rate",
    //   width: "10%",
    //   placeholder: "Exchange Rate",
    // },
    {
      dataNode: "total_cost_value",
      width: "10%",
    },
  ],
  searchSelectAbove: 10,
  detailFields: [
    { dataNode: "is_revised", label: "Revised", inputType: "select", selectOptions: [], colSpan: 2 },
    { dataNode: "component_id", label: "Component", inputType: "select", selectOptions: [], colSpan: 3 },
    { dataNode: "eps", label: "EPS", inputType: "multisearchselect", selectOptions: [], placeholder: "Search episodes" },
    { dataNode: "loc_work_type_id", label: "Localization Work Type", inputType: "select", selectOptions: [] },
    { dataNode: "notes", label: "Notes", inputType: "textarea" },
  ],
  showActionsItemBottom:[
    {
    dataNode: "po_line_id",
    width: "7%",
  },
  {
    dataNode: "description",
    width: "32%",
  },
  {
    dataNode: "quantity",
    width: "6%",
  },
  {
    dataNode: "unit_cost",
    width: "7%",
  },
  // {
  //   dataNode: "subtotal_value",
  //   width: "10%",
  // },
  // {
  //   dataNode: "adj_curr_exch_rate",
  //   width: "0%",
  // },
  // {
  //   dataNode: "currency_code",
  //   width: "0%",
  // },
  
  
  {
    dataNode: "actual_cost",
    width: "40%",
    inputType: "number",
    fieldWidth:"30%"
  },
  {
    dataNode: "is_revised",
    width: "3%",
  }],
  actions: ["copy", "info-circle", "pen", "trash-alt"],
  isClearFields: true,
}; 
export const optionalRightsList = [

];

export const poStatusOptions = [
  { label: "In Progress", value: "In Progress" },
  { label: "Sent to Vendor", value: "Sent to Vendor" },
  {
    label: "50% Invoice Sent for Processing",
    value: "50% Invoice Sent for Processing",
  },
  {
    label: "Full Invoice Sent for Processing",
    value: "Full Invoice Sent for Processing",
  },
];

export const defaultPoStatus = poStatusOptions[0].value;

export const NewPOHeader = {
  po_id: null,
  po_number: null,
  po_prefix: null,
  vendor_id: null,
  vendor_location_id: null,
  notes: null,
  show_season_id: null,
  is_void: 0,
  prod_company_id: null,
  episode_id: null,
  po_status: defaultPoStatus,
};

export const NewPOLine = [
  {
    po_line_id: null,
    po_id: null,
    episode_id: null,
    //gl_number: null,
    // setunit_id: null,
    // set_unit: null,
    // chartofaccount_id: null,
    acc_detail: null,
    description: null,
    target_language_id: null,
    service_id: null,
    component_id: null,
    loc_work_type_id: null,
    quantity: null,
    unit_cost: null,
    subtotal: null,
    total_cost: null,
    currency_code: null,
    created_by: null,
    created_at: null,
    updated_at: null,
    updated_by: null,
    notes: null,
    change_log: [],
  },
];

export const revised = [
  { label: "Y", value: "Y" },
  { label: "N", value: "N" },
];